/**
 * An epoch counts as filled once its traded volume reaches this share of the CMS target.
 * Shared so the API's underfill alert and Skywalker's "Epochs Filled" card can't drift apart.
 */
export const EPOCH_VOLUME_FILLED_RATIO = 0.98;
